/** SIGTERM wait when the bridge CLI is closing (Ctrl+C); 0 = SIGKILL immediately if still running. */
export const BRIDGE_CLOSE_PREVIEW_ENVIRONMENT_GRACE_MS = 0;

/** Default SIGTERM wait for preview-environment child teardown outside bridge exit. */
export const BRIDGE_SHUTDOWN_GRACE_MS = 8000;

/** SIGTERM grace before SIGKILL when stopping a preview environment from the UI. */
export const PREVIEW_ENVIRONMENT_STOP_GRACE_MS = 2500;
